import type { ReactNode } from 'react';
import { LEGAL_META } from '../../content/legal/legalMeta';
import { LegalFooter } from './LegalFooter';

export type LegalPageLayoutProps = {
  title: string;
  children: ReactNode;
};

export function LegalPageLayout({ title, children }: LegalPageLayoutProps) {
  return (
    <div className="min-h-dynamic-screen bg-background-light text-[#111818]">
      <a href="#legal-main" className="skip-link">
        Skip to main content
      </a>
      <header className="border-b border-neutral-soft bg-white/80 backdrop-blur-sm sticky top-0 z-10">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between gap-4">
          <a
            href="/"
            className="font-bold text-[#111818] hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 rounded"
          >
            ← {LEGAL_META.brandMark}
          </a>
          <span className="text-sm text-[#638888]">Legal</span>
        </div>
      </header>
      <main id="legal-main" className="max-w-3xl mx-auto px-4 sm:px-6 py-10 sm:py-14" tabIndex={-1}>
        <h1 className="text-3xl sm:text-4xl font-black font-display tracking-tight text-[#111818] mb-2">
          {title}
        </h1>
        <p className="text-sm text-[#638888] mb-10">
          Effective {LEGAL_META.effectiveDate} · Last updated {LEGAL_META.lastUpdated}
        </p>
        <div className="legal-prose space-y-10">{children}</div>
      </main>
      <LegalFooter />
    </div>
  );
}
